export default __webpack_public_path__ + "static/graph-56a498d74e06c9fecd315cde34a94f9e.svg";